import React, { useCallback, useContext, useEffect, useState } from "react";
import { DContext } from "../../../context/Datacontext";
import { Pagination } from "../../../utils/Pagination";
import { fetchCourseStatus } from "../../../services/coures/fetchCourseStatus";

export const SpecialDiscount = () => {
    const { BeURL } = useContext(DContext);

    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [total, setTotal] = useState(0);

    const [selectedCourse, setSelectedCourse] = useState(null);
    const [price, setPrice] = useState("");
    const [discount, setDiscount] = useState("");
    const [discountStartDate, setDiscountStartDate] = useState("");
    const [discountEndDate, setDiscountEndDate] = useState("");
    const [saving, setSaving] = useState(false);

    const finalPrice =
        price && discount ? price - (price * discount) / 100 : price;

    const loadData = useCallback(async () => {
        try {
            setLoading(true);
            const res = await fetchCourseStatus({
                BeURL,
                type: "all",
                page,
                limit,
            });

            if (res?.success) {
                setCourses(res.courses || []);
                setTotalPages(res.totalPages || 1);
                setTotal(res.total || 0);
            }
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    },[BeURL,limit,page]);

    useEffect(() => {
        loadData();
    }, [page, limit, loadData]);

    const openModal = (course) => {
        setSelectedCourse(course);
        setPrice(course.price || "");
        setDiscount(course.discountPercent || "");
    };

    const closeModal = () => {
        setSelectedCourse(null);
        setPrice("");
        setDiscount("");
    };

    const updatePricing = async () => {
        try {
            setSaving(true);

            await fetch(`${BeURL}/course/pricing/${selectedCourse._id}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({
                    price: Number(price) || 0,
                    discountPercent: Number(discount) || 0,
                    discountStartDate: discountStartDate || null,
                    discountEndDate: discountEndDate || null,
                }),
            });

            closeModal();
            loadData();
        } catch (err) {
            console.log(err);
        }

        setSaving(false);
    };

    return (
        <div className="p-8 space-y-6 bg-gray-50 min-h-screen">
            <h2 className="text-2xl font-bold">
                Pricing & Monetization Management
            </h2>

            {loading ? (
                <div>Loading...</div>
            ) : (
                <div className="bg-white rounded-xl shadow overflow-hidden">
                    <table className="min-w-full text-sm">
                        <thead className="bg-gray-100 text-xs uppercase text-gray-600">
                            <tr>
                                <th className="p-4 text-left">Course</th>
                                <th className="p-4 text-left">Instructor</th>
                                <th className="p-4 text-center">Status</th>
                                <th className="p-4 text-center">Price</th>
                                <th className="p-4 text-center">Discount</th>
                                <th className="p-4 text-center">Discount Value</th>
                                <th className="p-4 text-center">Final Price</th>
                                <th className="p-4 text-center">Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {courses.map((course) => {
                                const finalPrice =
                                    (course.price || 0) -
                                    ((course.price || 0) *
                                        (course.discountPercent || 0)) /
                                    100;

                                const lastStatus =
                                    course.status?.length > 0
                                        ? course.status[course.status.length - 1].stage
                                        : "draft";

                                return (
                                    <tr
                                        key={course._id}
                                        className="border-t transition hover:bg-gray-50"
                                    >
                                        <td className="p-4 font-semibold">
                                            {course.title}
                                        </td>

                                        <td className="p-4">
                                            {course.createdBy?.name || "Instructor"}
                                        </td>

                                        <td className="p-4 text-center capitalize">
                                            <span
                                                className={`px-3 py-1 rounded-full text-xs font-semibold ${lastStatus === "approved"
                                                        ? "bg-green-100 text-green-600"
                                                        : lastStatus === "pending"
                                                            ? "bg-yellow-100 text-yellow-600"
                                                            : lastStatus === "rejected"
                                                                ? "bg-red-100 text-red-600"
                                                                : "bg-gray-100 text-gray-600"
                                                    }`}
                                            >
                                                {lastStatus}
                                            </span>
                                        </td>

                                        <td className="p-4 text-center">
                                            ₹{course.price || 0}
                                        </td>

                                        <td className="p-4 text-center">
                                            {course.discountPercent || 0}%
                                        </td>

                                        <td className="p-4 text-center text-red-500">
                                            ₹{(course.price || 0) - finalPrice}
                                        </td>

                                        <td className="p-4 text-center font-semibold text-green-600">
                                            ₹{finalPrice}
                                        </td>

                                        <td className="p-4 text-center space-x-3">
                                            <button
                                                onClick={() => openModal(course)}
                                                className="px-4 py-1.5 rounded-lg text-white
                        bg-primary-600 hover:bg-primary-700
                        transition-all duration-300"
                                            >
                                                Set Price
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}

            <Pagination
                page={page}
                totalPages={totalPages}
                limit={limit}
                totalUsers={total}
                setPage={setPage}
                setLimit={setLimit}
            />

            {/* ================= MODAL ================= */}
            {selectedCourse && (
                <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl p-6 w-96 space-y-4 shadow-xl animate-[fadeIn_.3s_ease]">
                        <h3 className="text-lg font-semibold">
                            Set Pricing - {selectedCourse.title}
                        </h3>
                        <div>
                            <label>Price :</label>
                            <input
                                type="number"
                                placeholder="Price ₹"
                                value={price}
                                onChange={(e) => setPrice(e.target.value)}
                                className="w-full border rounded-lg px-3 py-2"
                            />
                        </div>
                        <div>
                        <label>Discount :</label>
                        <input
                            type="number"
                            placeholder="Discount %"
                            value={discount}
                            onChange={(e) => setDiscount(e.target.value)}
                            className="w-full border rounded-lg px-3 py-2"
                        />
                        </div>
                         <div>
                        <label>Discount Start Date :</label>
                        <input
                            type="date"
                            value={discountStartDate}
                            onChange={(e) => setDiscountStartDate(e.target.value)}
                            className="w-full border rounded-lg px-3 py-2"
                        />
                        </div>
                        <div>
                        <lable>Discount End Date :</lable>
                        <input
                            type="date"
                            value={discountEndDate}
                            onChange={(e) => setDiscountEndDate(e.target.value)}
                            className="w-full border rounded-lg px-3 py-2"
                        />
                        </div>

                        {price && (
                            <div className="bg-gray-50 p-3 rounded text-sm">
                                <p>Original Price: ₹{price}</p>
                                {discount > 0 && (
                                    <p className="font-semibold text-green-600">
                                        Final Price: ₹{Math.round(finalPrice)}
                                    </p>
                                )}
                            </div>
                        )}

                        <div className="flex justify-end gap-3 pt-2">
                            <button
                                onClick={closeModal}
                                className="px-4 py-2 border rounded-lg"
                            >
                                Cancel
                            </button>

                            <button
                                onClick={updatePricing}
                                disabled={saving}
                                className="px-4 py-2 rounded-lg bg-primary-600 text-white hover:bg-primary-700"
                            >
                                {saving ? "Saving..." : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
